var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMetaStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3996 22.2625C15.8396 21.0175 16.9721 19.9975 17.7971 19.2025C18.6371 18.3925 19.3346 17.5525 19.8896 16.6825C20.4446 15.8125 20.7221 14.9425 20.7221 14.0725C20.7221 13.1725 20.5046 12.4675 20.0696 11.9575C19.6496 11.4475 18.9821 11.1925 18.0671 11.1925C17.1821 11.1925 16.4921 11.4775 15.9971 12.0475C15.5171 12.6025 15.2621 13.3525 15.2321 14.2975H12.7571C12.8021 12.5875 13.3121 11.2825 14.2871 10.3825C15.2771 9.4675 16.5296 9.01 18.0446 9.01C19.6796 9.01 20.9546 9.46 21.8696 10.36C22.7996 11.26 23.2646 12.46 23.2646 13.96C23.2646 15.04 22.9871 16.0825 22.4321 17.0875C21.8921 18.0775 21.2396 18.97 20.4746 19.765C19.7246 20.545 18.7646 21.4525 17.5946 22.4875L16.5821 23.3875H23.7146V25.525H12.7796V23.6575L14.3996 22.2625Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaStep2);
export default __webpack_public_path__ + "static/media/meta-step2.6e1f4baf0e403f17d2a7b0e098ae1bb8.svg";
export { ForwardRef as ReactComponent };